import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

const pad = (n) => String(n).padStart(2, "0");
const toIso = (d, m, y) => `${y}-${pad(m)}-${pad(d)}`;

export const parseDay = (txt) => {
  const now = new Date();
  const m = txt.trim().match(/^(\d{1,2})(?:[\/\-.](\d{1,2})(?:[\/\-.](\d{2,4}))?)?$/);
  if (!m) return null;
  const d = +m[1], mo = m[2] ? +m[2] : now.getMonth() + 1;
  let y = m[3] ? +m[3] : now.getFullYear();
  if (y < 100) y += 2000;
  if (d < 1 || d > 31 || mo < 1 || mo > 12) return null;
  const dt = new Date(y, mo - 1, d);
  return dt.getDate() === d ? toIso(d, mo, y) : null;
};

export const DayInput = ({ value, onChange, maxToday = true, ...props }) => {
  const [txt, setTxt] = useState("");
  useEffect(() => { if (value) { const [y, m, d] = value.split("-"); setTxt(`${+d}/${+m}/${y}`); } }, [value]);
  const commit = () => {
    const iso = parseDay(txt);
    if (!iso) { if (value) { const [y, m, d] = value.split("-"); setTxt(`${+d}/${+m}/${y}`); } return; }
    const today = new Date().toISOString().slice(0, 10);
    onChange(maxToday && iso > today ? today : iso);
  };
  return <Input inputMode="numeric" placeholder="Jour (ex. 5) ou 5/10/2026" value={txt} onChange={(e) => setTxt(e.target.value)} onBlur={commit}
    onKeyDown={(e) => { if (e.key === "Enter" || e.key === "Tab") commit(); props.onKeyDown?.(e); }} title="Tapez juste le jour (1, 2, 3…) : le mois et l'année en cours sont ajoutés automatiquement" {...props} />;
};
